import _ from 'lodash'
import { invalidActionSlice } from './slice'

const invalidActionActions = {
	...invalidActionSlice.actions,
}

export default invalidActionActions
